/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '95vw',
    maxHeight: '90vh',
    // height: '90vh',
  },

  overlay: {
    zIndex: 999999,
  },
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement(document.body); // eslint-disable-line

const ModalComponent = ({
  children,
  afterOpen,
  contentLabel,
  closeModal,
  open = true,
  ...props
}) => {
  function afterOpenModal() {
    if (afterOpen) {
      afterOpen();
    }
  }

  function close() {
    closeModal();
  }

  return (
    <Modal
      isOpen={open}
      onAfterOpen={afterOpenModal}
      onRequestClose={close}
      style={customStyles}
      contentLabel={contentLabel}
      {...props}
    >
      <button type="button" onClick={closeModal} className="modal-close">
        &times;
      </button>

      {children}
    </Modal>
  );
};

ModalComponent.propTypes = {
  children: PropTypes.node.isRequired,
  afterOpen: PropTypes.func.isRequired,
  contentLabel: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ModalComponent;
